import React, { useEffect, useState } from 'react'
import TokenService from '../../services/Authentication/TokenService';
import { urlTelerik } from '../../services/http-common';
import themeBase from '../../utils/theme/themeBase';
import { IExportarReporte, IParametro } from '../../Interfaces/base/IBase';
import reporteServicio from '../../services/reporteService';
import { CommandBar, ICommandBarItemProps } from '@fluentui/react';
import IconHelper from '../../utils/helpers/iconHelper';
import { TelerikReportViewer } from "@progress/telerik-react-report-viewer";


export interface IBaseReportesTelerik {
    // isOpen: boolean;
    // onDismiss: () => void;
    reportName: string,
    parametros: {} | undefined,
    formatos?: number,
    viewMode?: string
    // reload: () => void;
}

const viewerContainerStyle = {
    // position: 'absolute',
    position: 'relative',
    width: '100%',
    // height: '100%',
    height: '90vh',
    ['font-family']: 'ms sans serif'
};

const telerikStyle = {
    position: 'relative',
    width: '100%',
    height: '85vh',
    clear: 'both',
    overflow: 'auto',
    fontFamily: 'ms sans serif'
}

export const BaseReportesTelerik = (props: IBaseReportesTelerik) => {

    const { reportName, parametros, formatos = 1, viewMode } = props; // Asignar valor por defecto directamente aquí
    const [currentFormatos, setCurrentFormatos] = useState(formatos);
    const [currentViewMode, setViewMode] = useState(viewMode);


    useEffect(() => {
        // Actualizar el estado si el prop 'formatos' cambia
        setCurrentFormatos(formatos);
    }, [formatos]);
    useEffect(() => {
        // Actualizar el estado si el prop 'formatos' cambia
        setViewMode(viewMode);
    }, [viewMode]);

    // useEffect(() => {
    //     console.log("Formatos:", currentFormatos);
    // }, [currentFormatos]);

    let t = TokenService.getToken();
    let viewerRef;
    const urlTelerikR = `${urlTelerik}/reports`;

    const [key, setKey] = useState(0);

    const viewerOptions = {
        serviceUrl: urlTelerikR,
        reportSource: {
            parameters: props.parametros,

            report: props.reportName,
            //parameters: { "editors": { "multiSelect": { "listaVerificacionId": "50884d84-fd34-43ff-9686-179542b5a7aa" } } },
        },
        viewerContainerStyle: themeBase.telerikStyleV2,
        // viewerContainerStyle: viewerContainerStyle,
        // viewMode: currentViewMode,
        viewMode: 'PRINT_PREVIEW',
        scaleMode: 'FIT_PAGE_WIDTH',
        // scaleMode: 'SPECIFIC',
        scale: 1.0,
        enableAccessibility: false,
        toolbar: {
            items: [
                {
                    type: 'togglePrintPreview',
                    text: 'Print',
                    visible: true
                },
                {
                    type: 'export',
                    text: 'Export',
                    visible: false
                }
            ]
        },
        authenticationToken: t,
        // ready: function () {
        //   //this.refreshReport();
        // }

    };

    const transformarParametros = (parametros: Record<string, string>): IParametro[] => {
        return Object.entries(parametros).map(([key, value]) => ({
            Key: key,
            Value: value,
        }));
    };

    function descargarReporte(extension: string) {
        const reporteExportar: IExportarReporte = {
            report: props.reportName,
            Extension: extension
        }
        if (props.parametros !== undefined) {
            if (props.parametros !== null) {
                console.log("----Parametros-----")
                console.log(props.parametros)
                //reporteExportar.Parametros=parametros;
                reporteExportar.Parametros = transformarParametros(props.parametros);
            }
        }
        reporteServicio.exportaReporte(reporteExportar)
            .then((response) => {
                if (response.status === 200) {
                    // response.json().then((data) => {
                    //   console.log("Datos de la respuesta:", data);
                    // });
                    //   console.log("Datos de la respuesta: Reporte generado ----");
                    //   console.log(response.data);
                    
                    const dataUrl = response.data;

                    // Create a link element
                    const link = document.createElement('a');
                    link.href = dataUrl;
                    link.download = 'reporte'; // Puedes obtener el nombre del archivo de la respuesta si está disponible

                    // Simulate a click on the link to trigger the download
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                }
                else {
                    console.error("Status:", response.status);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    // Función para recargar el componente
    const recargarComponente = () => {
        setKey(prevKey => prevKey + 1);
    };

    const _items: ICommandBarItemProps[] = [
        {
            ...IconHelper.ICON_RELOAD,
            // onClick: (arg) => actualizarTabla(),
            // onClick: () => viewerRef.refreshReport(),
            onClick: recargarComponente,
        }
    ];

    const getFarItems = () => {
        if (currentFormatos === 1) {
            return [
                {
                    ...IconHelper.ICON_PDF,
                    onClick: () => {
                        descargarReporte("PDF");
                    },
                }
            ];
        } else if (currentFormatos === 2) {
            return [
                {
                    ...IconHelper.ICON_PDF,
                    onClick: () => {
                        descargarReporte("PDF");
                    },
                },
                {
                    ...IconHelper.ICON_EXCEL,
                    onClick: () => {
                        descargarReporte("XLSX");
                    },
                }
            ];
        } else {
            return [];
        }
    };

    const _farItems: ICommandBarItemProps[] = getFarItems();


    // const _farItems: ICommandBarItemProps[] = [
    //     {
    //         ...IconHelper.ICON_PDF,
    //         onClick: () => {
    //             descargarReporte("PDF");
    //         },
    //     },
    //     {
    //         ...IconHelper.ICON_EXCEL,
    //         onClick: () => {
    //             descargarReporte("XLSX");
    //         },
    //     }
    // ];

    useEffect(() => {
        const hideExportButton = () => {
            const exportButton: any = document.querySelector("#trv-main-menu-export-command");
            // console.log(exportButton)

            if (exportButton) {
                // console.log(exportButton)
                exportButton.remove();
                // exportButton.style.display = 'none';
                clearInterval(interval);
            }
        };

        // Usa un intervalo para asegurar que el botón sea encontrado y ocultado
        const interval = setInterval(hideExportButton, 1);

        // Limpia el intervalo al desmontar el componente
        return () => clearInterval(interval);
    }, [key]);


    useEffect(() => {
        // Actualizar el estado si el prop 'formatos' cambia
        // recargarComponente();
        viewerRef.refreshReport()
    }, [props.reportName]);

    return (
        <>
            {/* <div>BaseReportesTelerik</div>
            <pre>{JSON.stringify("--------exsisteExperiencias---", null, 2)}</pre>
            <pre>{JSON.stringify(currentFormatos, null, 2)}</pre>
            <pre>{JSON.stringify("--------exsisteExperiencias---", null, 2)}</pre>
            <pre>{JSON.stringify(props.reportName, null, 2)}</pre> */}
            <div className="ms-Grid-col ms-sm12 ms-lg12">
                <CommandBar
                    items={_items}
                    farItems={_farItems}
                    styles={themeBase.commadStyles}
                />
            </div>
            <div key={key}>
                <TelerikReportViewer
                    ref={el => viewerRef = el}
                    serviceUrl={viewerOptions.serviceUrl}
                    reportSource={viewerOptions.reportSource}
                    //viewerContainerStyle={viewerOptions.viewerContainerStyle}
                    viewerContainerStyle={viewerOptions.viewerContainerStyle}
                    parametersAreaVisible={true}
                    viewMode={viewerOptions.viewMode}
                    scaleMode={viewerOptions.scaleMode}
                    scale={viewerOptions.scale}
                    enableAccessibility={viewerOptions.enableAccessibility}
                    authenticationToken={viewerOptions.authenticationToken}
                    toolbarItems={viewerOptions.toolbar.items}
                    skipBlankPages={false}
                />
            </div>


        </>
    )
}
